import { type TouchEvent, useCallback, useRef, useState } from "react";

const SWIPE_THRESHOLD_PX = 30;

export const useMarketCalculatorLineCollapse = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const touchStart = useRef<{ x: number; y: number } | null>(null);

  const collapse = useCallback(() => setIsCollapsed(true), []);
  const expand = useCallback(() => setIsCollapsed(false), []);
  const toggleCollapsed = useCallback(
    () => setIsCollapsed((prev) => !prev),
    []
  );

  const handleTouchStart = useCallback((e: TouchEvent) => {
    touchStart.current = {
      x: e.touches[0].clientX,
      y: e.touches[0].clientY,
    };
  }, []);

  const handleTouchEnd = useCallback((e: TouchEvent) => {
    if (!touchStart.current) return;
    const deltaX = touchStart.current.x - e.changedTouches[0].clientX;
    const deltaY = touchStart.current.y - e.changedTouches[0].clientY;
    touchStart.current = null;

    // Mostly-vertical upward swipe expands the collapsed strip.
    if (deltaY < SWIPE_THRESHOLD_PX || Math.abs(deltaY) <= Math.abs(deltaX)) {
      return;
    }

    setIsCollapsed(false);
  }, []);

  return {
    isCollapsed,
    collapse,
    expand,
    toggleCollapsed,
    expandSwipeHandlers: {
      onTouchStart: handleTouchStart,
      onTouchEnd: handleTouchEnd,
    },
  };
};
